const CONTEXT_TYPE = {
  LOGIN_FORM: 1,
  REGISTER_FORM: 2,
  CANDIDATE_FORM: 3,
  OTP_FORM: 4,
};

export default CONTEXT_TYPE;
